import { environment } from "@env/environment";
import { ExperienceType, HubMode } from "@shared/models";

export function getEditorTargetUrl(mode: HubMode | ExperienceType | undefined) {
  return (mode === HubMode.space
    || mode === ExperienceType.mixed
    || mode === ExperienceType.only360) ?
    environment.labsUrl : environment.proUrl;
}

export function getRoomUrl(mode: HubMode | ExperienceType | undefined) {
  return getEditorTargetUrl(mode) + "/embed/"
}

export function getRoomEditorUrl(mode: HubMode | ExperienceType | undefined) {
  return getEditorTargetUrl(mode) + "/room-editor"
}

export function validateCurrentUrl(expectedUrl: string): boolean {
  return window.location.origin === expectedUrl;
}